import React, { useState, useEffect } from "react";
import "./Otp.scss";
import { useTranslation } from "react-i18next";
import {useNavigate, useSearchParams} from "react-router-dom";
import useDigitInput from "react-digit-input";
import {
  appData,
  authOtp,
  authResendVerify,
} from "../../../../core/axios/services";
import { Snackbar } from "@mui/material";
import Logo from "../../../components/Comon/Logo/Logo";

const OTP_LENGTH = 5;
const OTP_ALLOWED_PATTERN = /^[a-zA-Z0-9]$/;
const OTP_VALIDATION_PATTERN = new RegExp(`^[A-Z0-9]{${OTP_LENGTH}}$`);

const Otp = ({ showGlobalSnackbar, sendAgain }) => {
  const { t, i18n } = useTranslation();
  const navigate = useNavigate();

  const storedEmail = localStorage.getItem("signUpEmail");
  const [email, setEmail] = useState(
    storedEmail ? storedEmail : localStorage.getItem("loginEmail")
  );

  // const [email, setEmail] = useState(localStorage.getItem("signUpEmail"));
  const [value, setValue] = React.useState("");

  const [logo, setLogo] = useState("/assets/logotm.png");
  const [showSnackBar, setShowSnackBar] = useState(false);
  const [snackMessage, setSnackMessage] = useState(false);

  const handleOtpChange = React.useCallback((nextValue) => {
    const normalizedValue = (nextValue || "")
      .replace(/[^a-zA-Z0-9]/g, "")
      .toUpperCase()
      .slice(0, OTP_LENGTH);

    setValue(normalizedValue);
  }, []);

  const digits = useDigitInput({
    acceptedCharacters: OTP_ALLOWED_PATTERN,
    length: OTP_LENGTH,
    value,
    onChange: handleOtpChange,
  });
  const isOtpValid = OTP_VALIDATION_PATTERN.test(value);

  useEffect(() => {
    collectAppData().then((data) => {
      // setLogo(data.logo);
    });

    if (sendAgain === true) {
      handleResend();
    }
  }, []);

  const collectAppData = async () => {
    return appData().then((res) => res.data.data);
  };

  const [searchParams] = useSearchParams();
  const planId = searchParams.get('planId');

  const handleSubmit = async () => {
    if (!isOtpValid) {
      return;
    }

    const code = value.toUpperCase();

    try {
      return await authOtp(email, code).then((res) => {
        if(planId){
          navigate("/details?planId=" + planId);
        }else{
          navigate("/details");
        }
      });
    } catch (error) {
      let message = i18n.t("thereWasAnError");
      if (error.response.status === 422 || error.response.status === 401) {
        message = error.response.data.errorMessage;
      }
      showGlobalSnackbar(message);
    }
  };

  const handleResend = async () => {
    try {
      return await authResendVerify(email).then((res) => {
        showGlobalSnackbar("Code resent to email");
      });
    } catch (error) {
      let message = i18n.t("thereWasAnError");
      if (error.response.status === 422 || error.response.status === 401) {
        message = error.response.data.errorMessage;
      }
      showGlobalSnackbar(message);
    }
  };

  const handleCancel = () => {
    navigate("/signup");
  };

  return (
    <div className="detailsWrapper">
      <Logo className="logo" src={logo} />

      <div className="otpWrapper">
        <div className="otpContent">
          <h2>{t("pleaseCheckEmail")}</h2>

          <p className="paragraph">
            {t("codeSendTo")} <strong>{email}</strong>
          </p>

          <div className="otpFields">
            <input inputMode="text" autoCapitalize="characters" autoFocus {...digits[0]} />
            <input inputMode="text" autoCapitalize="characters" {...digits[1]} />
            <input inputMode="text" autoCapitalize="characters" {...digits[2]} />
            <input inputMode="text" autoCapitalize="characters" {...digits[3]} />
            <input inputMode="text" autoCapitalize="characters" {...digits[4]} />
          </div>

          <input
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            hidden
          />

          <div className="resendCode">
            {t("didntGetCode")}
            <button onClick={handleResend}>{t("resendClick")}</button>
          </div>

          <div className="verifyButton">
            <button className="verifySubmit" onClick={handleSubmit} disabled={!isOtpValid}>
              {t("verifyAcc")}
            </button>
            <button className="verifyCancel" onClick={handleCancel}>
              {t("denySurveyDeleteButton")}
            </button>
          </div>
        </div>
      </div>

      <Snackbar
        open={showSnackBar}
        autoHideDuration={2000}
        message={snackMessage}
      />
    </div>
  );
};

export default Otp;
